import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyStartNewFax = lazy(() => import('./svg-components/start-new-fax'));

const StartNewFax = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyStartNewFax {...rest} />
  </Suspense>
);

export default StartNewFax;
